/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailboxItemLinkDTO } from './MailboxItemLinkDTO';
import {
    MailboxItemLinkDTOFromJSON,
    MailboxItemLinkDTOFromJSONTyped,
    MailboxItemLinkDTOToJSON,
    MailboxItemLinkDTOToJSONTyped,
} from './MailboxItemLinkDTO';

/**
 * 
 * @export
 * @interface MailboxForwardDTO
 */
export interface MailboxForwardDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof MailboxForwardDTO
     */
    To: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailboxForwardDTO
     */
    Cc?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxForwardDTO
     */
    Body: string;
    /**
     * 
     * @type {Array<MailboxItemLinkDTO>}
     * @memberof MailboxForwardDTO
     */
    Links?: Array<MailboxItemLinkDTO> | null;
}

/**
 * Check if a given object implements the MailboxForwardDTO interface.
 */
export function instanceOfMailboxForwardDTO(value: object): value is MailboxForwardDTO {
    if (!('To' in value) || value['To'] === undefined) return false;
    if (!('Body' in value) || value['Body'] === undefined) return false;
    return true;
}

export function MailboxForwardDTOFromJSON(json: any): MailboxForwardDTO {
    return MailboxForwardDTOFromJSONTyped(json, false);
}

export function MailboxForwardDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxForwardDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'To': json['To'],
        'Cc': json['Cc'] == null ? undefined : json['Cc'],
        'Body': json['Body'],
        'Links': json['Links'] == null ? undefined : ((json['Links'] as Array<any>).map(MailboxItemLinkDTOFromJSON)),
    };
}

export function MailboxForwardDTOToJSON(json: any): MailboxForwardDTO {
    return MailboxForwardDTOToJSONTyped(json, false);
}

export function MailboxForwardDTOToJSONTyped(value?: MailboxForwardDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'To': value['To'],
        'Cc': value['Cc'],
        'Body': value['Body'],
        'Links': value['Links'] == null ? undefined : ((value['Links'] as Array<any>).map(MailboxItemLinkDTOToJSON)),
    };
}

